import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "./types";
import LocalStorage from "../../../util/storage";

const initialState: AppState = {
	apiError: null,
	darkMode: LocalStorage.isDarkMode(),
	hideMascot: LocalStorage.get("hideMascot") ?? false
};

export const slice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setApiError: (state, action: PayloadAction<string | null>) => {
			state.apiError = action.payload;
		},
		setDarkMode: (state, action: PayloadAction<boolean>) => {
			state.darkMode = action.payload;
			LocalStorage.setDarkMode(action.payload);
		},
		setHideMascot: (state, action: PayloadAction<boolean>) => {
			state.hideMascot = action.payload;
			LocalStorage.set("hideMascot", action.payload);
		}
	}
});

export const { setApiError, setDarkMode, setHideMascot } = slice.actions;

export default slice.reducer;
